"use client";
import React from "react";

interface ElementTagLabelProps {
  /**
   * The HTML element to display the tag for
   */
  element: HTMLElement;
}

/**
 * A label that displays the tag name of an HTML element
 */
export function ElementTagLabel({ element }: ElementTagLabelProps) {
  return (
    <div className="absolute top-[0.5px] left-[0.5px] bg-[rgba(52,53,65,0.8)] rounded text-xs text-white py-0.5 px-1.5 pointer-events-none">
      {element.tagName.toLowerCase()}
    </div>
  );
}
